import React, { useState } from 'react';
import { Container, Row, Col, Card, Nav, Table } from "react-bootstrap";
import { Helmet } from 'react-helmet';
import './cij.css';
import './zartecbutton.css';
import img1 from '../Components/Images/Laser/UV Laser1.png';
import img2 from '../Components/Images/Laser/UV Laser2.png';
import img3 from '../Components/Images/applications/uv1.png';
import img4 from '../Components/Images/applications/uv2.png';
import img5 from '../Components/Images/applications/uv3.png';
import img6 from '../Components/Images/applications/uv4.png';
import img7 from '../Components/Images/applications/uv5.png';
import img8 from '../Components/Images/applications/uv6.png';
import img9 from '../Components/Images/applications/uv7.png';
import img10 from '../Components/Images/applications/uv8.png';
import img11 from '../Components/Images/applications/uv9.png';

function LaserUVPrinters() {
    const [activeTab, setActiveTab] = useState('specifications');
    const [activePrinter, setActivePrinter] = useState(null);
    const specsSectionRef = React.useRef(null);

    // SEO Metadata
    const seoData = {
        title: "Industrial UV Laser Marking Machines | ZAR-LASER Printer Solutions",
        description: "High-quality CE-certified UV laser marking machines for industrial use. Maintenance-free non-contact laser printers for wood, acrylic, plastics and metals. QR code and barcode marking solutions.",
        keywords: "UV laser marking machine, maintenance free laser printer, non-contact laser printer, qr code laser printing, industrial laser printer supplier, best laser printer for industrial usage, CE-certified laser marking machine, ZAR-LASER marking machine distributor, laser printer for wood and acrylic",
        canonicalUrl: "https://zartecsolutions.com/laser-uv-printers"
    };

    // Product descriptions with SEO keywords
    const productDescriptions = {
        printer5W: "The ZAR Laser UV-5W is a high-performance UV laser marking machine perfect for industrial applications. This maintenance-free laser printer offers non-contact marking on various materials including wood, acrylic, plastics, and metals. CE-certified for safety and quality.",
        printer10W: "Our industrial-grade ZAR Laser UV-10W provides powerful UV laser marking capabilities for QR codes, serial numbers, and logos. This non-contact laser printer is ideal for high-speed production lines and offers reliable, permanent marking on diverse surfaces."
    };

    const specificationData = [
        { label: 'Laser Type', value: 'LEAD TECH 5W UV Laser Printer' },
        { label: 'Model', value: 'LT05U' },
        { label: 'Output Power', value: '5W' },
        { label: 'Beam quality M²', value: '≤1.2' },
        { label: 'Pulse frequency', value: '20-200 kHz' },
        { label: 'Laser wavelength', value: '355nm' },
        { label: 'Output power diameter', value: '0.7±0.1mm' },
        { label: 'Working life', value: 'About 20,000 hours (maintenance-free operation)' },
        { label: 'Marking range', value: '100~300mm (range optional)' },
        { label: 'Engraving depth', value: '≤1mm (depending on power and time)' },
        { label: 'Engraving speed', value: '≤10000mm/s' },
        { label: 'Repeat accuracy', value: '±0.002' },
        { label: 'Minimum marking line width', value: '0.1mm' },
        { label: 'Minimum character height', value: '0.15mm' },
        { label: 'Cooling system', value: 'External water cooling' },
        { label: 'Power supply', value: '500W / 220V / 50Hz (110V can be connected)' },
        { label: 'Operating conditions', value: '0~40°C, 30% RH ~85% (air conditioner required outside range)' },
        { label: 'Certification', value: 'CE-certified laser marking machine' },
        { label: 'Operating system', value: 'Flying marking system' },
        { label: 'Supported formats', value: 'Text, QR code, barcode, serial number, graphics' },
        { label: 'Dimensions', value: '660×510×1460 mm' },
        { label: 'Weight', value: 'About 89kg (including cooling system)' }
    ];

    const specificationData1 = [
        { label: 'Laser Type', value: 'LEAD TECH 10W UV Laser Printer' },
        { label: 'Model', value: 'LT10U' },
        { label: 'Output Power', value: '10W (industrial-grade performance)' },
        { label: 'Beam quality M²', value: '≤1.2' },
        { label: 'Pulse frequency', value: '40-300 kHz' },
        { label: 'Laser wavelength', value: '355nm' },
        { label: 'Output power diameter', value: '0.8±0.1mm' },
        { label: 'Working life', value: 'About 20,000 hours (maintenance-free operation)' },
        { label: 'Marking range', value: '100~300mm (range optional)' },
        { label: 'Engraving depth', value: '≤1mm (depending on power and time)' },
        { label: 'Engraving speed', value: '≤10000mm/s (high-speed production capable)' },
        { label: 'Repeat accuracy', value: '±0.002' },
        { label: 'Minimum marking line width', value: '0.1mm' },
        { label: 'Minimum character height', value: '0.15mm' },
        { label: 'Cooling system', value: 'External water cooling' },
        { label: 'Power supply', value: '500W / 220V / 50Hz (110V can be connected)' },
        { label: 'Operating conditions', value: '0~40°C, 30% RH ~85% (air conditioner required outside range)' },
        { label: 'Certification', value: 'CE-certified laser marking machine' },
        { label: 'Operating system', value: 'Flying marking system' },
        { label: 'Supported formats', value: 'Text, QR code, barcode, serial number, graphics' },
        { label: 'Dimensions', value: '660×510×1460 mm' },
        { label: 'Weight', value: 'About 89kg (including cooling system)' }
    ];

    const applicationData = [
        { id: 1, image: img3, alt: 'Plastic marking with UV laser', title: 'Plastic Marking' },
        { id: 2, image: img4, alt: 'Plastic rigid content laser engraving', title: 'Rigid Plastics' },
        { id: 3, image: img5, alt: 'UV laser printed plastic containers', title: 'Plastic Containers' },
        { id: 4, image: img6, alt: 'Metal parts laser marking', title: 'Metal Parts' },
        { id: 5, image: img7, alt: 'Glass engraving with UV laser', title: 'Glass Marking' },
        { id: 6, image: img8, alt: 'Plastic packaging laser coding', title: 'Packaging Coding' },
        { id: 7, image: img9, alt: 'Flexible film laser printing', title: 'Flexible Films' },
        { id: 8, image: img10, alt: 'Plastic components laser marking', title: 'Plastic Components' },
        { id: 9, image: img11, alt: 'Industrial laser printing on films', title: 'Industrial Films' },
    ];

    const handleProductClick = (printerId) => {
        setActivePrinter(printerId);
        setActiveTab('specifications');

        setTimeout(() => {
            specsSectionRef.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }, 50);
    };

    const printers = [
        {
            id: 1,
            model: "ZAR Laser UV - 5W",
            description: productDescriptions.printer5W,
            image: img1,
            specifications: {
                keyFeatures: [
                    {
                        title: "Reliable & High Performance",
                        features: [
                            "Optimized power output to ensure longer lifetime",
                            "No consumables, long term maintenance free",
                            "Working life about 20,000 hours",
                            "IP54 rating ensures maximum reliability and uptime"
                        ]
                    },
                    {
                        title: "High Quality Coding",
                        features: [
                            "Clear & permanent codes, easy to read",
                            "Engrave technology for anti-counterfeiting and traceability"
                        ]
                    },
                    {
                        title: "Increase Product Efficiency",
                        features: [
                            "Advanced system ensures messages in fast processing",
                            "Engraving speed ≤10000mm/s",
                            "Used in medium-speed or high-speed production lines"
                        ]
                    },
                    {
                        title: "Easy to Use",
                        features: [
                            "New compact design, easy to install anywhere",
                            "10.4 inch touch screen, WYSIWYG, easy to operate",
                            "Support up to 14 languages, meet what you need"
                        ]
                    }
                ],
                technical: specificationData,
                applications: applicationData
            }
        },
        {
            id: 2,
            model: "ZAR Laser UV - 10W",
            description: productDescriptions.printer10W,
            image: img2,
            specifications: {
                keyFeatures: [
                    {
                        title: "Reliable & High Performance",
                        features: [
                            "Optimized power output to ensure longer lifetime",
                            "No consumables required, long term maintenance free",
                            "Working life about 20,000 hours",
                            "IP54 rating ensures maximum reliability and uptime"
                        ]
                    },
                    {
                        title: "High Quality Coding",
                        features: [
                            "Clear & permanent codes, easy to read",
                            "Engrave technology for anti-counterfeiting and traceability"
                        ]
                    },
                    {
                        title: "Increase Product Efficiency",
                        features: [
                            "Advanced system ensures messages in fast processing",
                            "Engraving speed ≤10000mm/s",
                            "Used in medium-speed or high-speed production lines"
                        ]
                    },
                    {
                        title: "Easy to Use",
                        features: [
                            "New compact design, easy to install anywhere",
                            "10.4 inch touch screen, WYSIWYG, easy to operate",
                            "Support up to 14 languages, meet what you need"
                        ]
                    }
                ],
                technical: specificationData1,
                applications: applicationData
            }
        }
    ];

    const renderKeyFeatures = (features) => {
        return features.map((group, index) => (
            <div key={index} style={{ marginBottom: '20px' }}>
                <h3 className="h5" style={{ color: '#00663b', marginBottom: '10px' }}>{group.title}</h3>
                <ul style={{ listStyle: 'none', paddingLeft: '20px' }}>
                    {group.features.map((feature, i) => (
                        <li key={i} style={{ position: 'relative', paddingLeft: '25px', marginBottom: '8px' }}>
                            <span style={{ 
                                position: 'absolute', 
                                left: 0,
                                color: '#00663b',
                                fontWeight: 'bold',
                                fontSize: '17px',
                            }}>•</span>
                            {feature}
                        </li>
                    ))}
                </ul>
            </div>
        ));
    };

    const renderTabContent = () => {
        if (!activePrinter) return <div className="p-5 text-center">Please select a printer to view details</div>;
        
        const printer = printers.find(p => p.id === activePrinter);
        if (!printer) return null;
        
        switch (activeTab) {
            case 'specifications':
                return (
                    <div style={{ padding: '20px' }}>
                        <h2 className="h4" style={{ marginTop: '10px', marginBottom: '20px' }}>Key Features</h2>
                        {renderKeyFeatures(printer.specifications.keyFeatures)}
                    </div>
                );
            case 'features':
                return (
                    <div style={{ padding: '20px' }}>
                        <h2 className="h4" style={{ marginTop: '10px', marginBottom: '20px' }}>Technical Specifications</h2>
                        <Table bordered hover responsive>
                            <tbody>
                                {printer.specifications.technical.map((item, index) => (
                                    <tr key={index}>
                                        <td className="bg-light" style={{ width: '30%', fontWeight: 'bold' }}>{item.label}</td>
                                        <td>{item.value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                );
            case 'applications':
                return (
                    <div style={{ padding: '20px' }}>
                        <h2 className="h4" style={{ marginTop: '10px', marginBottom: '20px' }}>Applications</h2>
                        <div className="row g-4">
                            {printer.specifications.applications.map((app) => (
                                <div key={app.id} className="col-md-6 col-lg-4 pb-5">
                                    <div className="card h-100 app-card shadow-sm">
                                        <img 
                                            src={app.image} 
                                            className="card-img-top" 
                                            alt={app.alt}
                                            style={{ height: '200px', objectFit: 'cover' }}
                                        />
                                        <div className="card-body">
                                            <h3 className="card-title text-center h5">{app.title}</h3>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="laser-uv-printers-page">
            <Helmet>
                <title>{seoData.title}</title>
                <meta name="description" content={seoData.description} />
                <meta name="keywords" content={seoData.keywords} />
                <link rel="canonical" href={seoData.canonicalUrl} />
                
                {/* Open Graph / Social Media Meta Tags */}
                <meta property="og:title" content={seoData.title} />
                <meta property="og:description" content={seoData.description} />
                <meta property="og:url" content={seoData.canonicalUrl} />
                <meta property="og:type" content="product" />
                
                {/* Twitter Card Meta Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content={seoData.title} />
                <meta name="twitter:description" content={seoData.description} />

                {/* Schema.org markup for Google */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Product",
                        "name": "ZAR-LASER UV Marking Machine",
                        "description": seoData.description,
                        "brand": {
                            "@type": "Brand",
                            "name": "ZAR-LASER"
                        },
                        "keywords": seoData.keywords
                    })}
                </script>
            </Helmet>

            <section className="product-header">
                <Container className="py-5">
                    <h1 className="mb-4 cijh2">Industrial UV Laser Marking Machines</h1>
                    <Row>
                        {printers.map(printer => (
                            <Col lg={4} md={6} className="mb-4" key={printer.id}>
                                <Card 
                                    className={`h-100 border-light shadow-sm rounded-3 ${activePrinter === printer.id ? 'border-primary' : ''}`}
                                    onClick={() => handleProductClick(printer.id)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <Card.Body className="d-flex flex-column">
                                        <div className="mb-2" 
                                            style={{
                                                background: "linear-gradient(135deg, #0A6E54 0%, #1B4B89 100%)",
                                                WebkitBackgroundClip: "text",
                                                backgroundClip: "text",
                                                color: "transparent",
                                                fontWeight: "bold",
                                                display: "inline-flex",
                                                alignItems: "center",
                                                textDecoration: "none",
                                                marginTop: "auto",
                                            }}>
                                            {printer.model}
                                        </div>
                                        <p className="text-muted">{printer.description}</p>
                                        <button 
                                            className="zartec-btn zartec-btn-primary zartec-btn-small"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleProductClick(printer.id);
                                            }}
                                            aria-label={`View details for ${printer.model}`}
                                        >
                                            View Product Details
                                        </button>
                                    </Card.Body>
                                    <div className="p-3 text-center">
                                        <img 
                                            src={printer.image} 
                                            alt={`${printer.model} UV Laser Marking Machine`} 
                                            className="img-fluid" 
                                            style={{ maxHeight: '200px' }} 
                                        />
                                    </div>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </section>
            
            {activePrinter && (
                <section ref={specsSectionRef} className="product-specifications">
                    <div className="product-navbar-container mb-4">
                        <Nav className="nav-tabs-custom d-flex justify-content-center">
                            <Nav.Item className="flex-fill text-center">
                                <Nav.Link 
                                    className={`px-4 py-3 ${activeTab === 'specifications' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('specifications')}
                                    aria-current={activeTab === 'specifications' ? 'page' : undefined}
                                >
                                    <span className="nav-text">Key Features</span>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="flex-fill text-center">
                                <Nav.Link 
                                    className={`px-4 py-3 ${activeTab === 'features' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('features')}
                                    aria-current={activeTab === 'features' ? 'page' : undefined}
                                >
                                    <span className="nav-text">Technical Specification</span>
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item className="flex-fill text-center">
                                <Nav.Link 
                                    className={`px-4 py-3 ${activeTab === 'applications' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('applications')}
                                    aria-current={activeTab === 'applications' ? 'page' : undefined}
                                >
                                    <span className="nav-text">Applications</span>
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                    </div>
                    <div className="border border-top-0 p-0 bg-white">
                        {renderTabContent()}
                    </div>
                </section>
            )}
        </div>
    );
}

export default LaserUVPrinters;